import React from "react";
import Tooltip from "../components/tooltip";
import { Box, Paper } from "@mui/material";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "react-i18next";

const KeywordDashboardTable = ({
  title,
  header,
  data,
  loading,
  handleFullPage,
  tooltip,
}) => {
  const { t } = useTranslation();

  return (
    <Paper elevation={3} className="h-100">
      <Box className="overview-table h-100" style={{ overflow: "hidden" }}>
        <TableContainer sx={{ overflow: "hidden" }}>
          <Typography
            variant="subtitle1"
            className="font-light-bold heading-medium mb-0 px-3 py-2"
            id="tableTitle"
            component="div"
          >
            {title}
            <Tooltip title={tooltip} />
          </Typography>
          <Box style={{ height: "240px" }} className="overview-table-cont">
            <Table aria-labelledby="tableTitle" size={"small"}>
              <TableHead>
                <TableRow>
                  {header?.map((item) => {
                    return (
                      <TableCell
                        scope="col"
                        key={`${title}-${item.label}`}
                        align={item?.align || "left"}
                        padding={"normal"}
                      >
                        {item.label}
                        {item.tooltip && <Tooltip title={item.tooltip} />}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <>
                    <TableRow key={`no-data`}>
                      <TableCell colSpan={2}>
                        <span className="d-flex align-items-center justify-content-center h-100">
                          <div className="spinner-border" role="status">
                            <span className="sr-only"></span>
                          </div>
                        </span>
                      </TableCell>
                    </TableRow>
                  </>
                ) : data?.length === 0 ? (
                  <>
                    <TableRow key={`no-data`}>
                      <TableCell colSpan={2}>
                        <span className="d-flex align-items-center justify-content-center h-100">
                          {t("keyword_research.keyword_overview.no_keywords")}
                        </span>
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  data?.slice(0, 6)?.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={`${title}-${index}`}
                        sx={{ cursor: "pointer" }}
                      >
                        {header?.map((item) => {
                          return (
                            <TableCell
                              align={item.align || "left"}
                              className={
                                item.id === "keyword" ? "keyword-name" : ""
                              }
                              key={item.id}
                            >
                              {row[item.id]}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </Box>
        </TableContainer>
        <div className="see-more-link" style={{ textDecoration: "auto" }}>
          <button
            className={`btn-sm float-right`}
            style={{ fontSize: "1em !important" }}
            onClick={handleFullPage}
          >
            {t("common_buttons.view_all")}
          </button>
        </div>
      </Box>
    </Paper>
  );
};

export default KeywordDashboardTable;
